import { Box } from '@mui/material';
import { Navigate, useLocation } from 'react-router';
import Section1 from './componenets/sections/components/Section1';
import Section2 from './componenets/sections/components/Section2';
import Session3 from './componenets/sections/components/Section3';
import Section4 from './componenets/sections/components/Section4';
import Section5 from './componenets/sections/components/Section5';
import Section6 from './componenets/sections/components/Section6';
import Section7 from './componenets/sections/components/Section7';
import Section8 from './componenets/sections/components/Section8';
import Footer from './componenets/footer/FooterSection';
import './LandingPage.scss';
import Navbar from './componenets/navbar/Navbar';

const LandingPage = () => {
  let lastVisitedPage = localStorage.getItem('lastVisitedPage');
  let token = localStorage.getItem('token');
  const { pathname } = useLocation();
  if (lastVisitedPage && token && pathname !== '/home') {
    return <Navigate to={lastVisitedPage} replace />;
  } else if (token && pathname !== '/home') {
    window.location.replace('/dashboard');
  }

  return (
    <Box className='landing-page'>
      <Box className='nav-section'>
        <Navbar />
      </Box>
      <Section1 />
      <Session3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Footer />
    </Box>
  );
};

export default LandingPage;
